import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    maxLength: Number,
    className: {
      type: String,
      default: "invalid-field"
    }
  }

  updateState(e) {
    if(e.target.value.length >= this.maxLengthValue) {
      this.element.classList.add(this.classNameValue)
    } else {
      this.element.classList.remove(this.classNameValue)
    }
  }
}
